"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const graphql_1 = require("..");
exports.createEmail = graphql_tag_1.default `
  mutation createEmail($data: CreateEmailInput!) {
    createEmail(data: $data) {
      ...emailDetailData
    }
  }
  ${graphql_1.emailDetailData(false)}
`;
exports.createEmailServerSide = graphql_tag_1.default `
  mutation createEmailServerSide(
    $data: EmailInput!
  ) {
    createEmailServerSide(
      data: $data
    ) {
      ...emailDetailData
    }
  }
  ${graphql_1.emailDetailData(false)}
`;
exports.createOrUpdateEmail = graphql_tag_1.default `
  mutation createOrUpdateEmail(
    $id: ID,
    $data: UpdateEmailInput!
  ) {
    createOrUpdateEmail(
      id: $id,
      data: $data
    ) {
      ...emailDetailData
    }
  }
  ${graphql_1.emailDetailData(false)}
`;
exports.softDeleteEmail = graphql_tag_1.default `
  mutation softDeleteEmail(
    $id: ID
  ){
    softDeleteEmail(
      id: $id
    )
  }
`;
exports.updateEmailLatestSubjectLines = graphql_tag_1.default `
  mutation updateEmailLatestSubjectLines(
    $id: ID!,
    $latestSubjectLines: [String!],
    $useNewLoaderFeature: Boolean
  ) {
    updateEmailLatestSubjectLines(
      id: $id,
      latestSubjectLines: $latestSubjectLines,
      useNewLoaderFeature: $useNewLoaderFeature
    ) {
      id
      emailNumber
      latestSubjectLines
    }
  }
`;
exports.createOrUpdateEmailMetaCampaign = graphql_tag_1.default `
  mutation createOrUpdateEmailMetaCampaign(
    $emailId: ID!,
    $emailName: String!,
    $assignedUserIds: [ID],
    $data: ESPCreateCampaignData!,
    $useNewLoaderFeature: Boolean
  ) {
    createOrUpdateEmailMetaCampaign(
      emailId: $emailId,
      emailName: $emailName,
      assignedUserIds: $assignedUserIds,
      data: $data,
      useNewLoaderFeature: $useNewLoaderFeature
    ) {
      ...emailDetailData
    }
  }
  ${graphql_1.emailDetailData(false)}
`;
exports.updateEmailToNewTemplateVersion = graphql_tag_1.default `
  mutation updateEmailToNewTemplateVersion(
    $id: ID!,
    $type: String!
  ) {
    updateEmailToNewTemplateVersion(
      id: $id,
      type: $type
    ) {
      ...emailDetailData
    }
  }
  ${graphql_1.emailDetailData(false)}
`;
//# sourceMappingURL=emails.js.map